// İndirme dosya adı yardımcıları.
//
// Adın TEK kaynağı sunucudur (`go/internal/api/handler/download_name.go`):
// `{ÜRÜN_ADI}_GSPR_{YYYYMMDDHHMMSS}.docx`. Panel `fetch` + blob ile indirdiği
// için tarayıcı `Content-Disposition`'a bakmaz — `a.download` ne derse onu
// yazar. Bu yüzden başlığı BİZ okuyup aynı adı kullanıyoruz; adı burada
// yeniden kurmak iki kaynak yaratır ve biri güncellenip diğeri unutulur.

// indirmeAdiCoz — Content-Disposition başlığından dosya adını çıkarır.
//
// RFC 6266: sunucu iki ad birden gönderir — `filename*` (UTF-8, gerçek ad)
// ve `filename` (ASCII yedeği). `filename*` VARSA O KAZANIR; Türkçe harf
// taşıyan ürün adları yalnız orada doğru gelir ("Şırınga" → yedekte
// "Siringa").
//
// Başlık okunamazsa null döner: bazı vekiller/CDN'ler CORS altında
// `Content-Disposition`'ı istemciye geçirmez (`Access-Control-Expose-Headers`
// olmadan görünmez). Çağıran o durumda kendi yedeğini kurar.
export function indirmeAdiCoz(header: string | null): string | null {
  if (!header) return null;

  // Önce filename*=UTF-8''… — yüzde kodlu.
  const yildizli = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(header);
  if (yildizli) {
    try {
      const ad = decodeURIComponent(yildizli[1].trim());
      if (ad) return temizle(ad);
    } catch {
      // Bozuk yüzde kodlaması — ASCII yedeğine düş.
    }
  }

  // Sonra filename="…" (veya tırnaksız).
  const duz = /filename\s*=\s*"([^"]+)"|filename\s*=\s*([^;]+)/i.exec(header);
  if (duz) {
    const ad = (duz[1] ?? duz[2] ?? "").trim();
    if (ad) return temizle(ad);
  }
  return null;
}

// temizle — sunucudan gelen adı da yol ayracına karşı süz. Sunucu zaten
// temizliyor; bu ikinci savunma, çünkü `a.download` içinde bir yol parçası
// tarayıcıya göre farklı yorumlanır.
function temizle(ad: string): string {
  const son = ad.split(/[\\/]/).pop() ?? "";
  return son.replace(/[\x00-\x1f\x7f]/g, "").trim();
}

// zamanDamgasi — sunucununkiyle AYNI biçim: YYYYMMDDHHMMSS, UTC.
//
// UTC bilinçli: kayıtlı bir doküman iki farklı makineden indirildiğinde aynı
// adı almalı. Yalnız başlık okunamadığında kullanılan yedek yoldur.
export function zamanDamgasi(d: Date = new Date()): string {
  const p = (n: number, u = 2) => String(n).padStart(u, "0");
  return (
    `${d.getUTCFullYear()}${p(d.getUTCMonth() + 1)}${p(d.getUTCDate())}` +
    `${p(d.getUTCHours())}${p(d.getUTCMinutes())}${p(d.getUTCSeconds())}`
  );
}
